module.exports = __webpack_public_path__ + "img/drake-logo.40bd8779.jpg";